export const customListValueFields = [{
        name: "displayOrder",
        title: "Ordine"
    }, {
        name: "description",
        title: "Descrizione"
    }];
